export const toggleArrayItem = (array, value) => {
  let index = array.indexOf(value);

  if (index === -1) {
    array.push(value);
  } else {
    array.splice(index, 1);
  }

  return array;
};

export const getWordEnding = (count, words) => {
    if (!Array.isArray(words)) return;
    
    if (words.length == 3) {
        const lastTwo = count % 100;
        if (lastTwo >= 11 && lastTwo <= 14) return words[2];
        const last = count % 10;
        if (last === 1) return words[0];
        if (last >= 2 && last <= 4) return words[1];
        return words[2];
    }

    return;
};